import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function Waitlist() {
  return (
    <section id="waitlist" style={section}>
      <div style={container}>
        <div style={box}>
          <div style={eyebrow}>Pilot update</div>
          <h2 style={h2}>EmPi’s first pilot is complete.</h2>
          <p style={p}>
            Thank you to everyone who took part and shared feedback. EmPi is
            preparing its next phase.
          </p>
          <p style={finePrint}>
            New pilot and waitlist registrations are currently paused.
          </p>
        </div>
      </div>
    </section>
  );
}

const section = {
  padding: empiTheme.layout.sectionPadding,
  background: empiTheme.colors.background,
};

const container = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
};

const box = {
  border: `1px solid ${empiTheme.colors.border}`,
  borderRadius: empiTheme.radius.card,
  padding: 24,
  background: "#FAFAFA",
  boxShadow: empiTheme.shadow.card,
};

const eyebrow = {
  ...empiTheme.typography.eyebrow,
  color: empiTheme.colors.textSecondary,
  marginBottom: 12,
};

const h2 = {
  fontSize: empiTheme.typography.h2.fontSize,
  lineHeight: empiTheme.typography.h2.lineHeight,
  margin: "0 0 8px",
  color: empiTheme.colors.text,
  maxWidth: 720,
};

const p = {
  margin: "0 0 16px",
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: empiTheme.typography.body.lineHeight,
  color: empiTheme.colors.text,
};

const finePrint = {
  marginTop: 12,
  fontSize: 13,
  color: empiTheme.colors.textSecondary,
};
